<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>Summer Holiday Notice</h3>
      <br>

      <p>
        We will be closed for summer holiday during the following period.<br>
        We apologize for any inconvenience this may cause and appreciate your understanding.
      </p>

      <p>
      -------------------------------------<br>
      Summer Holiday: Tuesday, August 11, 2026 – Sunday, August 16, 2026<br>
      -------------------------------------<br>
      </p>

      <p>
        ・Orders & Lamp Replacements
      </p>

      <p>
      -------------------------------------<br>
      ■Cosmetics, Consumables, and Beauty Devices：<br>
	Orders placed by 14:00 on Monday, August 10, 2026<br>
　	→ Shipped the same day<br>
      -------------------------------------<br>
      </p>

      <p>
      -------------------------------------<br>
      ■Lamp Replacements, etc.:<br>
	Items arriving by the morning of Monday, August 10, 2026<br>
　	→ Shipped the same day<br>
	※Please note that same-day processing may not be possible depending on the order details.<br>
      -------------------------------------<br>
      </p>

	 <p>
        Orders and inquiries received after the above dates will be processed sequentially from Monday, August 17, 2026.<br>
        Thank you for your understanding.
      </p>


      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news251226',
  props: {
    largescreen: {
      type: Boolean
    }
  },
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>